import cookie from "react-cookies";
import {Redirect, Route} from "react-router-dom";
import {getDefaultEndpoint} from "utils/endpoint_utils";
import {authenticationStatus} from "../utils/const";
import {store} from './store';
import {notNull} from "../utils/utils";
import {logout} from "../redux_actions/login.action";

export const PrivateRoute = ({component: Component, ...rest}) => (
    <Route
        {...rest}
        render={props => {
            if (JSON.parse(localStorage.getItem('showLogoutModal'))) {
                store.dispatch(logout(null, null))
            } else {
                if (rest.status === authenticationStatus.PENDING) {
                    return null;
                } else if (rest.status === authenticationStatus.AUTHENTICATED) {
                    // TODO : If want to use `/change_password/` somewhere else please fix this functionality:
                    //  change_password without passwordChangedByOtherUser local storage value will redirect
                    //  to dashboard page
                    if (window.location.pathname !== '/change_password/' && JSON.parse(localStorage.getItem('passwordChangedByOtherUser'))) {
                        return <Redirect to={{pathname: '/change_password/', state: {from: props.location}}}/>
                    } else if (window.location.pathname === '/change_password/' && !JSON.parse(localStorage.getItem('passwordChangedByOtherUser'))) {
                        return <Redirect to={{pathname: '/dashboard/', state: {from: props.location}}}/>
                    } else {
                        return <Component {...props} />
                    }
                } else {
                    return <Redirect to={{pathname: '/login/', state: {from: props.location}}}/>
                }
            }
        }}/>
);

export const LoginRoute = ({component: Component, ...rest}) => (
    <Route {...rest} render={props => {
        if (store.getState().loginAlerts.authVerificationStatus === authenticationStatus.AUTHENTICATED &&
            (store.getState().loginAlerts.status === true || cookie.loadAll().token !== undefined)) {
            const prevPath = props?.location?.state?.from?.pathname;
            const pathname = notNull(prevPath) && store.getState().loginAlerts.isSameUserLoggedInStatus ? prevPath : getDefaultEndpoint();
            return <Redirect to={{pathname: pathname, state: {from: props.location}}}/>
        } else {
            return <Component {...props} />
        }
    }}/>
);


const unsubscribe = store.subscribe(PrivateRoute)
unsubscribe()
